import { render, staticRenderFns } from "./FeaturesCheckboxes.vue?vue&type=template&id=4350b58b&"
import script from "./FeaturesCheckboxes.vue?vue&type=script&lang=js&"
export * from "./FeaturesCheckboxes.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports